import Card, { CardContent, CardHeader, CardFooter } from "../Card"
import SkeletonBase from "./SkeletonBase"

/**
 * Skeleton pour CourseCard
 * Reproduit la structure de CourseCard.jsx
 */
export default function CourseCardSkeleton({ index = 0 }) {
  return (
    <Card
      className="group hover:shadow-xl transition-all duration-500 overflow-hidden border-0 shadow-md opacity-100"
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      {/* Image skeleton */}
      <div className="relative overflow-hidden">
        <SkeletonBase 
          className="w-full h-40" 
          height="10rem"
          rounded="rounded-none"
        />
        
        {/* Badge skeleton */}
        <div className="absolute top-3 right-3">
          <SkeletonBase 
            className="w-20 h-6" 
            width="5rem"
            height="1.5rem"
            rounded="rounded-full"
          />
        </div>
      </div>

      <CardHeader className="p-6 pb-3">
        <div className="flex items-center justify-between mb-2">
          {/* Category badge skeleton */}
          <SkeletonBase 
            className="w-24 h-5" 
            width="6rem"
            height="1.25rem"
            rounded="rounded-full"
          />
          {/* Rating skeleton */}
          <SkeletonBase 
            className="w-12 h-4" 
            width="3rem"
            height="1rem"
          />
        </div>
        {/* Title skeleton */}
        <SkeletonBase 
          className="h-5 mb-2" 
          height="1.25rem"
        />
        <SkeletonBase 
          className="h-5 w-3/4" 
          width="75%"
          height="1.25rem"
        />
        {/* Description skeleton */}
        <div className="mt-2 space-y-2">
          <SkeletonBase 
            className="h-4" 
            height="1rem"
          />
          <SkeletonBase 
            className="h-4 w-5/6" 
            width="83%"
            height="1rem"
          />
        </div>
      </CardHeader>

      <CardContent className="px-6 pb-6 pt-0">
        {/* Duration skeleton */}
        <SkeletonBase 
          className="w-24 h-4" 
          width="6rem"
          height="1rem"
        />
      </CardContent>

      <CardFooter className="px-6 pb-6 pt-0 flex flex-col gap-3">
        {/* Price skeleton */}
        <div className="flex items-center justify-between w-full">
          <SkeletonBase 
            className="w-20 h-6" 
            width="5rem"
            height="1.5rem"
            rounded="rounded-full"
          />
        </div>
        {/* Button skeleton */}
        <SkeletonBase 
          className="w-full h-10" 
          height="2.5rem"
          rounded="rounded-md"
        />
      </CardFooter>
    </Card>
  )
}
